import { Button } from '@medeloop/medeloop-components-library';
import { useTranslation } from 'react-i18next';
import { OrganizationNotFoundIcon } from 'src/assets/organization-not-found-icon';

export function OrganizationNotFoundScreen() {
  const { t } = useTranslation();

  // Placeholder while we figure out what to do with this
  const handleContactOrg = () => {
    console.log('contact organization');
  };

  return (
    <div className="flex flex-grow flex-col justify-center items-center bg-gray-950 gap-6">
      <OrganizationNotFoundIcon className="" />
      <div className="flex flex-col items-center gap-6">
        <span className="text-white font-semibold text-3xl">{t('no_org_assigned')}</span>
        <span className="text-gray-100">{t('request_admin_to_join_org')}</span>
        <Button onClick={handleContactOrg} variant="primary">
          {t('contact_administrator')}
        </Button>
      </div>
    </div>
  );
}
